// extracted by mini-css-extract-plugin
export default {"root":"manageTemplates_root__Ekvxm","content":"manageTemplates_content__C2ItR"};